import React from 'react';

export const MarCountryModal = {
  title: 'Marigram Country',
  body: (
    <div>
      <p>Country of tide gauge observation.</p>
    </div>
  ),
};
